export { getMetadataFieldLabel } from '../../../../utils/const';

export const DEFAULT_METADATA_KEYS = {
  COMPANY_NAME: 'company_name',
  COMPANY_OVERVIEW: 'company_overview',
  STT_KEYWORDS: 'stt_keywords',
} as const;

export const RESERVED_METADATA_KEYS: ReadonlySet<string> = new Set([
  DEFAULT_METADATA_KEYS.COMPANY_NAME,
  DEFAULT_METADATA_KEYS.COMPANY_OVERVIEW,
  DEFAULT_METADATA_KEYS.STT_KEYWORDS,
]);

export const LOCKED_METADATA_KEYS: ReadonlySet<string> = new Set([
  'demo_url_expired_at',
]);

export const METADATA_KEY_VALIDATION = {
  PATTERN: /^[a-z]+(_[a-z]+)*$/,
  IN_PROGRESS_PATTERN: /^[a-z]+(_[a-z]+)*_?$/,
  EXAMPLE: 'company_name',
  PLACEHOLDER: 'e.g. company_name',
  EMPTY_ERROR: 'Key is required',
  NUMBER_ERROR:
    'Numbers are not allowed. Use lowercase letters and underscores only. e.g. company_name',
  UPPERCASE_ERROR: 'Use lowercase letters only. e.g. company_name',
  SPECIAL_CHAR_ERROR:
    'Special characters are not allowed. Use lowercase letters and underscores only. e.g. company_name',
  FORMAT_ERROR:
    'Use lowercase letters separated by underscores. e.g. company_name',
} as const;
